module.exports = __webpack_public_path__ + "static/img/speed.ba34f95f.svg";